import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  styled,
} from '@mui/material';
import { ReactComponent as UserIcon } from '../../assets/icons/userManagement.svg';
import { ReactComponent as GeoIcon } from '../../assets/icons/geoManagement.svg';
// import { ReactComponent as GrowerIcon } from '../../assets/icons/growerManagement.svg';
// import { ReactComponent as OrganizerIcon } from '../../assets/icons/organizerManagement.svg';
// import { ReactComponent as FieldIcon } from '../../assets/icons/fieldManagement.svg';
// import { ReactComponent as MaterialIcon } from '../../assets/icons/materialManagement.svg';
import { MVPFiltersProps } from '../advanta-mvp-charts/constants';

const HoverCard = styled(Card)(() => ({
  borderRadius: 12,
  border: '1px solid #e5e5e5',
  boxShadow: 'none',
  transition: 'all 0.3s ease',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'rgba(239, 245, 246, 1)',
  },
  '&:hover .svg-icon path': {
    fill: 'rgba(2, 105, 93, 1)',
  },
}));

const cardData = [
  {
    icon: UserIcon,
    title: 'User Management',
    description:
      'Manage all app users, their roles & import users.',
    path: 'userManagement',
  },
  {
    icon: GeoIcon,
    title: 'Geography',
    description:
      'Manage geography information such as village, region and sub-region',
    path: 'geographyManagement',
  },
  // {
  //   icon: GrowerIcon,
  //   title: 'Grower Management',
  //   description:
  //     'Manage growers, their details and status.',
  //   path: 'growthManagement',
  // },
  // {
  //   icon: OrganizerIcon,
  //   title: 'Organizer Management',
  //   description:
  //     'Manage organizer profiles, their details and status.',
  //   path: 'organizerManagement',
  // },
  // {
  //   icon: FieldIcon,
  //   title: 'Field Management',
  //   description:
  //     'Track and manage complete field data and production plans.',
  //   path: 'fieldManagement',
  // },
  // {
  //   icon: MaterialIcon,
  //   title: 'Material Management',
  //   description:
  //     'Manage crop information such as code, season & productivity.',
  //   path: 'materialManagement',
  // },
];

export const AdminUI: React.FC<MVPFiltersProps> = ({
  onNavigate,
}) => {
  const handleCardClick = (path: string) => {
    onNavigate?.(path);
  };
  return (
    <Box
      sx={{
        p: 4,
        backgroundColor: '#f9f9f9',
        minHeight: '100vh',
      }}>
      <Typography
        variant="subtitle2"
        sx={{ mb: 3, fontWeight: 600 }}>
        Admin Settings
      </Typography>
      <Grid container spacing={3}>
        {cardData.map((item, index) => {
          const Icon = item.icon;
          return (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <HoverCard
                onClick={() => handleCardClick(item.path)}>
                <CardContent
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                  }}>
                  <Icon
                    className="svg-icon"
                    style={{
                      width: 68,
                      height: 68,
                      // fill: '#757575', // default grey
                      transition: 'fill 0.3s ease',
                    }}
                  />
                  <Box>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: 600,
                        color: '#333',
                      }}>
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#666',
                        mt: 0.5,
                        lineHeight: 1.4,
                      }}>
                      {item.description}
                    </Typography>
                  </Box>
                </CardContent>
              </HoverCard>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
